// 前台多语言 & 公开路由（全部 requiresAuth: false）
export default [
  {
    path: '/:lang(en-HK|zh-HK|zh-CN|ja|ko)',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/components/home.vue'),
    children: [
      {
        path: '/',
        redirect: '/en-HK/'
      },
      {
        path: '',
        name: 'HomePage',
        component: () => import(/* webpackChunkName: "HomePage" */ '@/components/HomePage.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'service-request-form',
        name: 'flightBookingRoute',
        component: () => import(/* webpackChunkName: "flightBookingRoute" */'@/components/fightBookingsModule/flightBookingRoute.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'service-request-form/flight-bookings',
        name: 'FlightBookings',
        component: () => import(/* webpackChunkName: "FlightBookings" */ '@/components/fightBookingsModule/flightBookings.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'case-status',
        name: 'caseStatus',
        component: () => import(/* webpackChunkName: "caseStatus" */ '@/components/caseStatus/caseStatus.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'refund-application',
        name: 'refundApplication',
        component: () => import(/* webpackChunkName: "refundApplication" */ '@/components/refundApplication/refundApplication.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'terms-of-use',
        name: 'TermsofUse',
        component: () => import(/* webpackChunkName: "TermsofUse" */  '@/components/refundApplication/TermsofUse.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'refundable-taxes',
        name: 'here',
        component: () => import(/* webpackChunkName: "refundApplicationHere" */ '@/components/refundApplication/refundApplicationHere.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'refund-status',
        name: 'refundStatus',
        component: () => import(/* webpackChunkName: "refundStatus" */ '@/components/refundStatus/refundStatus.vue'),
        meta: { requiresAuth: false },
      },
      {
        path: 'survey',
        name: 'satisfaction',
        component: () => import(/* webpackChunkName: "satisfactionPage" */  '@/components/Satisfaction/satisfactionPage.vue'),
        meta: { requiresAuth: false },
      },
      // ...其它公开页面...
    ]
  },
  {
    path: '/service-request-form',
    redirect: '/en-HK/service-request-form'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import( /* webpackChunkName: "NotFound" */ '@/components/theLogin/NotFound.vue'),
  },
  // {
  //   path: '/:pathMatch(.*)*',
  //   redirect: ''
  // }
];